import React from "react";
import imglogo from "../../../assets/img/logo_t4i.png";
import bgAuthenticate from "../../../assets/img/bg-authenticate.png";
import "../login.css";
import "./ForgetPassword.css";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import createHttp from "../../../lib/http";

function ForgetPassword() {
	const history = useHistory();
	const [step, setStep] = React.useState("email");
	const [email, setEmail] = React.useState("");
	const [code, setCode] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [passwordConfirmation, setPasswordConfirmation] = React.useState("");
	const [error, setError] = React.useState("");
	const [isLoading, setIsLoading] = React.useState(false);

	const gotoLogin = () => {
		history.push("/");
	};

	const apiMessage = (res) => {
		if (!res || !res.data) {
			return "SERVER ERROR";
		}
		return res.data.message || res.data.msg || "Something went wrong";
	};

	const requestCode = async (e) => {
		e.preventDefault();
		if (isLoading) return;
		setError("");
		setIsLoading(true);
		try {
			const res = await createHttp.post("api/requestResetPassword", { email });
			if (res?.data?.status) {
				setStep("code");
			} else {
				setError(apiMessage(res));
			}
		} catch (err) {
			setError("SERVER ERROR");
		} finally {
			setIsLoading(false);
		}
	};

	const submitNewPassword = async (e) => {
		e.preventDefault();
		if (isLoading) return;
		setError("");
		if (password !== passwordConfirmation) {
			setError("Passwords do not match");
			return;
		}
		if (password.length < 8) {
			setError("Password must be at least 8 characters");
			return;
		}
		setIsLoading(true);
		try {
			const res = await createHttp.post("api/resetPassword", {
				email,
				code,
				password,
				password_confirmation: passwordConfirmation,
			});
			if (res?.data?.status) {
				history.push("/");
			} else {
				setError(apiMessage(res));
			}
		} catch (err) {
			setError("SERVER ERROR");
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="login">
			<div className="hero-split">
				<img
					alt="Tech4Inventory Warehouse"
					className="hero-image"
					src={bgAuthenticate}
				/>
			</div>

			<div className="form-split">
				<div className="form-container__forget-password form-container">
					<div className="form-container_top">
						<img src={imglogo} alt="logo" className="logo" />
						<h1 className="title-app">Tech4Inventory</h1>
						<span className="subtitle-app">
							{step === "email"
								? "Reset your password"
								: "Enter the code we sent to your email"}
						</span>
						<div className="information-content__signup">
							Already registered? <span onClick={gotoLogin}>Sign In</span>
						</div>
					</div>

					{step === "email" ? (
						<form className="form" onSubmit={requestCode}>
							<div className="theinputs">
								<div className="input-group">
									<label className="label" htmlFor="emailForget">
										Email
									</label>
									<div className="relative-input-wrapper">
										<span className="input-icon material-symbols-outlined">mail</span>
										<input
											type="email"
											className={classNames("input input-email input-with-icon", {
												"is-invalid": !!error,
											})}
											name="emailForget"
											id="emailForget"
											placeholder="user@tech4inventory.com"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											required
										/>
									</div>
								</div>
								{error && (
									<p className="message_error">
										<span>{error}</span>
									</p>
								)}
								<button type="submit" className="primary-button" disabled={isLoading}>
									{isLoading ? "Sending…" : "Send code"}
								</button>
							</div>
						</form>
					) : (
						<form className="form" onSubmit={submitNewPassword}>
							<div className="theinputs">
								<div className="input-group">
									<label className="label" htmlFor="resetCode">
										Verification code
									</label>
									<div className="relative-input-wrapper">
										<input
											type="text"
											className="input"
											name="resetCode"
											id="resetCode"
											placeholder="1234"
											value={code}
											onChange={(e) => setCode(e.target.value)}
											required
										/>
									</div>
								</div>
								<div className="input-group">
									<label className="label" htmlFor="resetPassword">
										New password
									</label>
									<div className="relative-input-wrapper">
										<span className="input-icon material-symbols-outlined">lock</span>
										<input
											type="password"
											className="input input-password input-with-icon"
											name="resetPassword"
											id="resetPassword"
											placeholder="••••••••"
											value={password}
											onChange={(e) => setPassword(e.target.value)}
											required
										/>
									</div>
								</div>
								<div className="input-group">
									<label className="label" htmlFor="resetPasswordConfirm">
										Confirm password
									</label>
									<div className="relative-input-wrapper">
										<span className="input-icon material-symbols-outlined">lock</span>
										<input
											type="password"
											className="input input-password input-with-icon"
											name="resetPasswordConfirm"
											id="resetPasswordConfirm"
											placeholder="••••••••"
											value={passwordConfirmation}
											onChange={(e) => setPasswordConfirmation(e.target.value)}
											required
										/>
									</div>
								</div>
								{error && (
									<p className="message_error">
										<span>{error}</span>
									</p>
								)}
								<button type="submit" className="primary-button" disabled={isLoading}>
									{isLoading ? "Saving…" : "Change password"}
								</button>
							</div>
						</form>
					)}
				</div>
			</div>
		</div>
	);
}

export { ForgetPassword }
export default ForgetPassword
